import { openAdmissionPrint } from '../config/openAdmissionPrint';
import React from "react";
import { admission, epayment, site } from "../config/api";
import { Dialog } from "evergreen-ui";
import { FaReceipt } from "react-icons/fa";
import { IoQrCodeOutline, IoClose } from "react-icons/io5";
import "./PaymentDialog.css";

function formatMoney(value) {
  const n = Number(value);
  if (!value || Number.isNaN(n)) return "-";
  return `${n.toLocaleString("th-TH")} บาท`;
}

export default function PaymentDialog({ isOpen, onClose }) {
  const handleClose = () => {
    localStorage.removeItem("TERMPAY");
    localStorage.removeItem("FNAME");
    localStorage.removeItem("LNAME");
    localStorage.removeItem("ID_NO");
    localStorage.removeItem("STOPDATE");
    localStorage.removeItem("AMOUNT");
    onClose();
  };

  const idNo = localStorage.getItem("ID_NO");
  const amount = localStorage.getItem("AMOUNT");
  const stopDate = localStorage.getItem("STOPDATE");
  const term = localStorage.getItem("TERMPAY") || localStorage.getItem("TERM");
  const fname = localStorage.getItem("FNAME");
  const lname = localStorage.getItem("LNAME");
  const fullName = [fname, lname].filter(Boolean).join(" ") || "-";

  const openBankSlip = () => {
    openAdmissionPrint(admission + "/dashboard_printbill?code_test=" + idNo);
  };

  const openOnlinePay = () => {
    window.open(
      `${epayment}?comp=80427&orderRef1=${idNo}&amount=${amount}&endDate=${stopDate}&urlredirect=${site}/admission/Dataregister&term=${term}&name=${fname}&lname=${lname}`
    );
  };

  return (
    <Dialog
      isShown={isOpen}
      hasHeader={false}
      hasFooter={false}
      width={520}
      onCloseComplete={handleClose}
      overlayProps={{ zIndex: 20000 }}
      containerProps={{ padding: 0, borderRadius: 16, overflow: "hidden" }}
      contentContainerProps={{ padding: 0 }}
    >
      <div className="pay-dialog">
        <header className="pay-dialog__hero">
          <button type="button" className="pay-dialog__close" onClick={handleClose} aria-label="ปิด">
            <IoClose size={18} />
          </button>
          <p className="pay-dialog__eyebrow">มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
          <h2 className="pay-dialog__title">ชำระเงินค่าสมัคร</h2>
          <p className="pay-dialog__subtitle">เลือกช่องทางที่สะดวก แล้วดำเนินการให้เสร็จภายในกำหนด</p>
        </header>

        <div className="pay-dialog__body">
          <div className="pay-dialog__summary">
            <div className="pay-dialog__field">
              <span className="pay-dialog__label">รหัสผู้สมัคร</span>
              <span className="pay-dialog__value">{idNo || "-"}</span>
            </div>
            <div className="pay-dialog__field">
              <span className="pay-dialog__label">ผู้สมัคร</span>
              <span className="pay-dialog__value">{fullName}</span>
            </div>
            <div className="pay-dialog__field">
              <span className="pay-dialog__label">จำนวนเงิน</span>
              <span className="pay-dialog__value pay-dialog__value--money">{formatMoney(amount)}</span>
            </div>
            <div className="pay-dialog__field">
              <span className="pay-dialog__label">ชำระภายใน</span>
              <span className="pay-dialog__value">{stopDate || "-"}</span>
            </div>
          </div>

          <div className="pay-dialog__methods">
            <button type="button" className="pay-dialog__method" onClick={openBankSlip}>
              <span className="pay-dialog__icon" aria-hidden="true">
                <FaReceipt />
              </span>
              <span className="pay-dialog__method-copy">
                <p className="pay-dialog__method-title">พิมพ์ใบแจ้งชำระเงิน</p>
                <p className="pay-dialog__method-desc">ดาวน์โหลดใบนำฝาก แล้วนำไปชำระที่เคาน์เตอร์ธนาคาร</p>
              </span>
            </button>

            <button type="button" className="pay-dialog__method pay-dialog__method--online" onClick={openOnlinePay}>
              <span className="pay-dialog__icon" aria-hidden="true">
                <IoQrCodeOutline />
              </span>
              <span className="pay-dialog__method-copy">
                <p className="pay-dialog__method-title">ชำระออนไลน์</p>
                <p className="pay-dialog__method-desc">QR PromptPay, แอปธนาคารกรุงไทย หรือบัตรเครดิต/เดบิต</p>
              </span>
            </button>
          </div>

          <div className="pay-dialog__brands">
            <img
              src="https://e-payment.kpru.ac.th/pay/public/images/Visa_Mastercard_jcb.jpg"
              alt="Visa Mastercard JCB"
            />
            <img
              src="https://e-payment.kpru.ac.th/pay/public/images/logo_ktb_next.png"
              alt="กรุงไทย Next"
            />
            <img
              src="https://e-payment.kpru.ac.th/pay/public/images/promtpay1.png"
              alt="PromptPay"
            />
          </div>
          <p className="pay-dialog__hint">ระบบชำระเงินของมหาวิทยาลัย ปลอดภัยและออกใบเสร็จอัตโนมัติ</p>
        </div>
      </div>
    </Dialog>
  );
}
